import React from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';


const Missing = () => {
  const navigate = useNavigate();


  const handleClick = () => {
    // Function to navigate to the home page
    navigate('/');
  };

  return (
    
    <Card className='h-full flex flex-row align-items-center justify-content-center'>
        <div className='missingPage'>
          <h1>404 - Page Not Found</h1>
          <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
          <Button label="Go to Home" icon="pi pi-home" onClick={handleClick} outlined/>
        </div>
    </Card>
  );
};

export default Missing;
